import mobileCarousel from '../utils/mobileCarousel';


const initIconBoxes = () => {
    mobileCarousel('icon-boxes__slider', 'swiper-pagination-icon-boxes', 1.4, 16);
}
initIconBoxes();

export default initIconBoxes;